import { useState } from 'react'
import { Link } from 'react-router-dom'

interface FailureDetailResult {
  agent_name: string
  status: 'pass' | 'fail' | 'dsq' | 'disagree'
  cost: number
  time: string
  run_id: string
  run_name: string
}

interface FailureDetailResultsProps {
  results: FailureDetailResult[]
}

function FailureDetailResults({ results }: FailureDetailResultsProps) {
  const [expanded, setExpanded] = useState(true)

  if (results.length === 0) return null

  return (
    <section data-testid="failure-detail-results" className="failure-detail-section failure-detail-stage">
      <div className="stage-section-header">
        <button
          className="stage-section-toggle"
          onClick={() => setExpanded(!expanded)}
          aria-expanded={expanded}
        >
          <span className="stage-section-toggle-icon" aria-hidden="true">{expanded ? '\u25BC' : '\u25B6'}</span>
          <h2 className="failure-detail-section-title">Agent Results</h2>
          <span className="clean-status-badge">{results.length} result{results.length !== 1 ? 's' : ''}</span>
        </button>
      </div>
      {expanded && (
        <table className="failure-detail-results-table" aria-label="Agent results">
          <thead>
            <tr>
              <th scope="col">Agent</th>
              <th scope="col">Status</th>
              <th scope="col">Cost</th>
              <th scope="col">Time</th>
              <th scope="col">Run</th>
            </tr>
          </thead>
          <tbody>
            {results.map((result, idx) => (
              <tr key={idx} data-testid={`failure-detail-result-${idx}`}>
                <td className="result-agent-cell">{result.agent_name}</td>
                <td>
                  <span className={`result-status-badge ${result.status}`}>
                    {result.status}
                  </span>
                </td>
                <td>${typeof result.cost === 'number' ? result.cost.toFixed(2) : result.cost}</td>
                <td>{result.time}</td>
                <td className="result-run-cell">
                  <Link
                    to={`/runs/${result.run_id}`}
                    className="result-run-link"
                    title={result.run_name}
                  >
                    <span className="result-run-link-text">{result.run_name}</span>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  )
}

export default FailureDetailResults
